import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { CustomNotificationPreferenceComponent } from './custom-notification-preference.component'

@NgModule({
  declarations: [CustomNotificationPreferenceComponent],
  imports: [CommonModule, SpinnerModule, I18nModule, MatSlideToggleModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        NotificationPreferenceComponent: {
          component: CustomNotificationPreferenceComponent
        }
      }
    })
  ],
  exports: [CustomNotificationPreferenceComponent]
})
export class CustomNotificationPreferenceModule {}
